import { useEffect, useRef, useState } from 'react';
import { WorldEffect, PARALLAX_CONFIGS } from './world-effects';

// Parallax layer speeds
const LAYER_SPEEDS = {
  farSky: 0.1,
  midTerrain: 0.3,
  nearTerrain: 0.5,
  particles: 0.7,
  foreground: 1.0
};

// Component for parallax layer
function ParallaxLayer({ children, speed, scrollY, className = '' }) {
  const translateY = scrollY * (1 - speed);
  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`} style={{ transform: `translateY(${translateY}px)`, willChange: 'transform' }}>
      {children}
    </div>
  );
}

// Main ParallaxBackground component
export function ParallaxBackground({ worldId = 1, scrollY = 0 }) {
  const containerRef = useRef(null);
  const [internalScrollY, setInternalScrollY] = useState(0);
  
  // Get world configuration
  const config = PARALLAX_CONFIGS[worldId] || PARALLAX_CONFIGS[1];
  const effectName = config?.farSky?.effect || 'fruitGarden';
  const gradient = config?.farSky?.gradient || PARALLAX_CONFIGS[1].farSky.gradient;
  
  useEffect(() => {
    if (scrollY !== undefined) {
      setInternalScrollY(scrollY);
    }
  }, [scrollY]);
  
  return (
    <div 
      ref={containerRef}
      className="absolute inset-0 overflow-hidden"
      style={{ background: gradient }}
    >
      {/* Far background layer */}
      <ParallaxLayer speed={LAYER_SPEEDS.farSky} scrollY={internalScrollY}>
        <WorldEffect effectName={effectName} />
      </ParallaxLayer>
    </div>
  );
}

// Re-export for backwards compatibility
export { PARALLAX_CONFIGS };
export default ParallaxBackground;
